import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../session/SessionContext";

const NoAccess: React.FC = () => {
  const navigate = useNavigate();
  const { user, signOut } = useSession();
  const hasHome = user?.role === "operator" || user?.organization != null;

  return (
    <Result
      status="403"
      title="No access"
      subTitle="Your account does not have access to this organization."
      extra={
        hasHome ? (
          <Button type="primary" onClick={() => navigate("/")}>
            Go to my organization
          </Button>
        ) : (
          <Button onClick={signOut}>Sign out</Button>
        )
      }
    />
  );
};

export default NoAccess;
